import BaseClient from '@/app/model/api/response/baseApiClient'

class DistrictDeleteApi extends BaseClient {
  public doDistrictDelete (id: string) {
    const path: string = '/v1/master/districts/' + id

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'DELETE')
  }
}

export default new DistrictDeleteApi()
